export default "__VITE_ASSET__DHSwlQ68__"